/* eslint-disable no-param-reassign */
// import { uniq, sortBy, groupBy } from 'lodash';
import { sortBy, uniq } from 'lodash';
import { groupIndicator } from '@/util/helper';
import ApiServices from '@/modules/data-layer/services/ApiServices';

const normalizeDatasourceName = (value) => String(value || '')
  .toLowerCase()
  .replace(/\s+/g, ' ')
  .trim();

const getDatasourceId = (source) => {
  const id = Number(
    source?.id
    ?? source?.['datasource_id']
    ?? source?.datasourceId
    ?? source?.dataSource
    ?? source?.datasource,
  );

  return Number.isFinite(id) ? id : null;
};

const getDatasourceNames = (source) => [
  source?.datasource,
  source?.['full_name'],
  source?.name,
  source?.['short_name'],
]
  .map(normalizeDatasourceName)
  .filter(Boolean);

const getDatasourceKeys = (source) => {
  const sourceId = getDatasourceId(source);
  const keys = getDatasourceNames(source).map((name) => `name:${name}`);

  if (sourceId !== null) {
    keys.push(`id:${sourceId}`);
  }

  return keys;
};

export default {
  data() {
    return {
      defaultIndicator: '',
      defaultDataSource: '',
      defaultLocation: '',
      defaultYear: '2022',
      defaultIndicatorDropdown: [],
      defaultDataSourceDropdown: [],
      defaultLocationDropdown: [],
      defaultYearDropdown: [],
      cpIsLoading: false,
    };
  },
  watch: {
    // The is the updated the control panels dropdown as indicator are gotten from the API
    // in the background (async)
    dlGetAvailableIndicators(newValue) {
      this.$store.commit('MSDAT_STORE/SET_ALL_CONTROL_OPTIONS', {
        key: 'indicator',
        payload: groupIndicator(newValue, 'program_area'),
      });
    },
  },
  methods: {
    cpGetAvailableYears(dataValues) {
      const years = dataValues?.map((item) => item.period);
      const uniqueYears = uniq(years);
      return sortBy(uniqueYears);
    },
    getSelectedIndicatorIds(indicator = this.payload?.indicator) {
      const selectedIndicators = Array.isArray(indicator) ? indicator : [indicator];

      return selectedIndicators
        .map((item) => Number(item?.id ?? item))
        .filter((id) => Number.isFinite(id));
    },
    getDatasourceIntersection(datasourceGroups = []) {
      if (datasourceGroups.length <= 1) {
        return datasourceGroups[0] || [];
      }

      const remainingGroupKeys = datasourceGroups.slice(1).map(
        (group) => new Set(group.flatMap(getDatasourceKeys)),
      );

      return datasourceGroups[0].filter((source) => {
        const sourceKeys = getDatasourceKeys(source);
        return remainingGroupKeys.every(
          (groupKeys) => sourceKeys.some((key) => groupKeys.has(key)),
        );
      });
    },
    async getDataSourcesForSelectedIndicators(indicator = this.payload?.indicator) {
      const indicatorIds = this.getSelectedIndicatorIds(indicator);

      if (indicatorIds.length === 0) {
        return [];
      }

      const datasourceGroups = await Promise.all(
        indicatorIds.map((indicatorId) => this.getDataSourcesFromIndicator(indicatorId)),
      );

      return this.getDatasourceIntersection(datasourceGroups);
    },
    getDatasourceAvailabilityOptions(availableDataSources = []) {
      const availableIds = new Set(
        availableDataSources
          .map(getDatasourceId)
          .filter((id) => id !== null),
      );
      const availableNames = new Set(
        availableDataSources.flatMap(getDatasourceNames),
      );
      const dashboardDataSources = this.dlGetDashboardDataSource();
      const sourceList = dashboardDataSources.length > 0 ? dashboardDataSources : availableDataSources;

      return sourceList.map((source) => {
        const sourceId = getDatasourceId(source);
        const sourceNames = getDatasourceNames(source);
        const isAvailable = (
          (sourceId !== null && availableIds.has(sourceId))
          || sourceNames.some((name) => availableNames.has(name))
        );

        return {
          ...source,
          isAvailable,
          datasourceAvailable: isAvailable,
          availabilityLabel: isAvailable ? 'Available' : 'Not Available',
          $isDisabled: !isAvailable,
        };
      });
    },
    setUpControlPanelDropDown() {
      // debugger;
      this.defaultIndicatorDropdown = groupIndicator(this.dlGetAvailableIndicators, 'program_area');

      this.$store.commit('MSDAT_STORE/SET_ALL_CONTROL_OPTIONS', {
        key: 'indicator',
        payload: this.defaultDataSourceDropdown,
      });
      this.defaultDataSourceDropdown = this.dlGetDashboardDataSource();

      this.$store.commit('MSDAT_STORE/SET_ALL_CONTROL_OPTIONS', {
        key: 'datasource',
        payload: this.defaultDataSourceDropdown,
      });

      this.defaultLocationDropdown = this.dlGetLocation({
        level: 3,
      });

      const location = this.dlGetLocation(1); // get nigerian Location object
      // add nigeria to the top of the array
      this.defaultLocationDropdown.unshift(location);

      this.defaultDataSourceDropdown = this.dlGetDashboardDataSource();

      this.$store.commit('MSDAT_STORE/SET_ALL_CONTROL_OPTIONS', {
        key: 'location',
        payload: this.defaultLocationDropdown,
      });
    },
    setDefaults() {
      this.defaultIndicator = this.dlGetIndicator(this.$store.state.MSDAT_STORE.default.indicator);
      this.defaultDataSource = this.dlGetDataSource(
        this.$store.state.MSDAT_STORE.default.datasource,
      );
      this.defaultLocation = this.dlGetLocation(this.$store.state.MSDAT_STORE.default.location);

      console.log('default indicator:', this.defaultIndicator);
      console.log('default datasource:', this.defaultDataSource);
      console.log('default location:', this.defaultLocation);
    },

    async setYearDropdown(
      indicatorID = this.defaultIndicator.id,
      dataSourceID = this.defaultDataSource.id,
      locationID = this.defaultLocation.id,
    ) {
      const response = await ApiServices.getPeriod({
        indicator: indicatorID,
        datasource: dataSourceID,
        location: locationID,
      });

      if (!response?.data?.periods) {
        return [];
      }

      const years = response.data.periods;
      return years.sort((a, b) => b - a);
    },
    // get years by datasource
    async setYearDropdownByDatasource(dataSourceID = this.defaultDataSource.id) {
      const data = await this.queryDBForYearByDs(dataSourceID);
      // debugger;
      // const onlyYearData = data?.filter((item) => {
      //   if (isDataYearly(item.period)) {
      //     return item.period;
      //   }
      //   return false;
      // });
      // const years = onlyYearData?.map((item) => item.period);
      // const uniqueYears = uniq(years);
      return data.sort((a, b) => b - a);
    },

    async setLocationDropdown(
      dataSourceID = this.defaultDataSource.id,
      indicatorID = this.defaultIndicator.id,
      // eslint-disable-next-line no-unused-vars
      controlIndex = 0,
    ) {
      if (!dataSourceID || !indicatorID) return;
      let data = [];

      if (Array.isArray(indicatorID)) {
        // eslint-disable-next-line no-restricted-syntax
        for (const ind of indicatorID) {
          // eslint-disable-next-line no-await-in-loop
          data = data.concat(await this.queryDBForAvailableLocation(dataSourceID, ind));
        }
      } else if (Array.isArray(dataSourceID)) {
        // eslint-disable-next-line no-restricted-syntax
        for (const dat of dataSourceID) {
          // eslint-disable-next-line no-await-in-loop
          data = data.concat(await this.queryDBForAvailableLocation(dat, indicatorID));
        }
      } else {
        data = await this.queryDBForAvailableLocation(dataSourceID, indicatorID);
      }

      // Commit the unique locations to the store
      this.$store.commit('MSDAT_STORE/SET_ALL_CONTROL_OPTIONS', {
        key: 'location',
        payload: data.sort((a, b) => a.id - b.id),
      });
      // let locations = this.dlGetLocation({ level: 3 });
      // locations.unshift(this.dlGetLocation(1));
      // locations = locations.filter(({ id }) => data.includes(id));

      // this.$store.commit('MSDAT_STORE/SET_ALL_CONTROL_OPTIONS', {
      //   key: 'location',
      //   payload: locations,
      // });

      // this.$store.commit('MSDAT_STORE/SET_PAYLOAD', {
      //   controlIndex,
      //   key: 'location',
      //   value: locations[0] || this.dlGetLocation(1),
      // });
    },

    // Get available DataSources
    async setDataSourcesDropdown(indicatorID = this.defaultIndicator.id) {
      const data = await this.getDataSourcesFromIndicator(indicatorID);

      // Restrict datasources for custom dashboards to configured dashboard datasources
      if (this.isCustomDashboardActive && this.isCustomDashboardActive()) {
        const configured = this.dlGetDashboardDataSource();
        const configuredIds = configured.map((c) => c.id);
        const filtered = data.filter((ds) => configuredIds.includes(ds.id));
        return filtered.length > 0 ? filtered : data;
      }

      return data;
    },
    // Get available Indicator
    // async setIndicatorDropdown(datasourceID = this.defaultDataSource.id) {
    //   const data = await this.getIndicatorFromDexie(datasourceID);

    //   console.log(data, 'indicator world');
    //   console.log(datasourceID, 'indicator world');

    //   const indicatorWithData = data.filter(async (indicatorItem) => {
    //     const indicatorData = await this.dlQuery({
    //       indicator: indicatorItem.id,
    //       datasource: datasourceID,
    //     });

    //     // Keep only items where indicatorData is not an empty array
    //     return indicatorData.length > 0;
    //   });
    //   const formattedData = groupIndicator(indicatorWithData, 'program_area');
    //   console.log(formattedData, 'indicatorWithData');
    //   return formattedData;
    // },
    async setIndicatorDropdown(datasourceID = this.defaultDataSource.id) {
      const data = await this.getIndicatorsFromDatasource(datasourceID);

      const formattedData = groupIndicator(data, 'program_area');
      return formattedData;

      // console.log(data, 'indicator world');
      // console.log(datasourceID, 'indicator world');

      // const indicatorWithDataPromises = data.map(async (indicatorItem) => {
      //   const indicatorData = await this.dlQuery({
      //     indicator: indicatorItem.id,
      //     datasource: datasourceID,
      //   });

      //   // Return the item if indicatorData has content, else return null
      //   return indicatorData.length > 0 ? indicatorItem : null;
      // });

      // // Await all promises and filter out any null values
      // const indicatorWithData = (await Promise.all(indicatorWithDataPromises)).filter(Boolean);

      // // console.log(indicatorWithData, 'indicator world');

      // const formattedData = groupIndicator(indicatorWithData, 'program_area');
      // return formattedData;
    },

    async setAllIndicatorDropdown(indicators) {
      const formattedData = groupIndicator(indicators, 'program_area');

      return formattedData;
    },
    async setIDCIndicatorDropdown(datasourceID = this.defaultDataSource.id) {
      const data = await this.getIndicatorsFromDatasource(datasourceID);

      const formattedData = groupIndicator(data, 'program_area');
      return formattedData;
    },

    async getAllDatasources() {
      const datasources = await this.getEveryDatasource();
      return datasources;
    },
  },
};
